module.exports = __webpack_public_path__ + "img/bannerbg_word.5868c53e.jpg";